import React from 'react';
import cx from 'classnames';
import {
  ErrorExplanationMarkCircleIcon,
  ErrorCheckCircleIcon,
  SuccessCheckCircleIcon
} from './icons';

interface Props {
  message: string;
  isDisclaimerPresent?: boolean;
  variant?: 'error' | 'success';
  position?: 'top' | 'bottom';
  id?: string;
  role?: string;
  'aria-live'?: 'off' | 'assertive' | 'polite';
  tabIndex?: number;
}

export const BannerMessage = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      message,
      position,
      variant,
      isDisclaimerPresent,
      id,
      role,
      'aria-live': ariaLive,
      tabIndex
    },
    ref
  ) => {
    return (
      <>
        {isDisclaimerPresent ? (
          <div
            data-testid="banner-message"
            ref={ref}
            id={id}
            role={role}
            aria-live={ariaLive}
            tabIndex={tabIndex}
            className={cx(
              `z-1 absolute top-full -mt-1 flex h-8 w-full items-center rounded-b-md pb-[5px] pl-4 pt-[6px] text-[10px]`,
              position === 'top' ? 'bottom-full' : 'top-full',
              variant === 'error' && 'bg-[#FFE2DE]',
              variant === 'success' && 'bg-[#CCF6E5]'
            )}
          >
            {variant === 'error' && <ErrorCheckCircleIcon className="mr-2" />}
            {variant === 'success' && (
              <SuccessCheckCircleIcon className="mr-2" />
            )}
            {message}
          </div>
        ) : (
          <div
            data-testid="banner-message"
            ref={ref}
            id={id}
            role={role}
            aria-live={ariaLive}
            tabIndex={tabIndex}
            className={cx(
              `font-size-xs absolute z-10 mt-2 flex w-full items-center rounded-lg p-2 text-left text-xs font-normal`,
              position === 'top' ? 'bottom-full' : 'top-full',
              variant === 'error' && 'bg-[#fcefee] text-[#D31400]',
              variant === 'success' && 'bg-[#ebfdf5] text-[#2CB87F]'
            )}
          >
            {variant === 'error' && (
              <ErrorExplanationMarkCircleIcon className="mr-2" />
            )}
            {variant === 'success' && (
              <SuccessCheckCircleIcon className="mr-2" />
            )}
            {message}
          </div>
        )}
      </>
    );
  }
);

BannerMessage.displayName = 'BannerMessage';
